import { TEntity, TGenericFeedback, TUserType } from '../utils'

// Product keys for other countries/entities
const ProductKeys = ['ALL_PRODUCTS'] as const

export const ALL_PRODUCTS = 'DISABLE_ALL_COMMUNICATION_CHANNELS'

type TProductKey = typeof ProductKeys[number]

// Product keys for BR - PF
const ProductKeysBrPf = [
  'TODOS_OS_PRODUTOS',
  'CAMBIO',
  'CARTAO_CREDITO',
  'CONSORCIO',
  'CONTA_DIGITAL',
  'CONTA_MEI',
  'DUO_GOURMET',
  'EMPRESTIMOS',
  'FORUM',
  'GIFT_CARD',
  'GLOBAL_ACCOUNT',
  'INTERCEL',
  'INVESTIMENTOS',
  'LOOP',
  'NEWSLETTER',
  'RECARGA_DE_CELULAR',
  'SEGUROS',
  'SHOPPING',
  'SORTEZINHA',
  'VIAGENS',
] as const
type TProductKeysBrPf = typeof ProductKeysBrPf[number]

// Product keys for BR - PJ
const ProductKeysBrPj = [
  'TODOS_PRODUTOS',
  'CAMBIO',
  'CARTAO',
  'CONTA_DIGITAL',
  'EMPRESTIMO',
  'FOLHA_DE_PAGAMENTO',
  'GESTAO_DE_COBRANCA',
  'GLOBAL_ACCOUNT',
  'INTEGRACAO',
  'INVESTIMENTO',
  'LOOP',
  'MAQUININHAS',
  'NEWSLETTER',
  'SEGUROS',
  'SHOPPING',
] as const
type TProductKeysBrPj = typeof ProductKeysBrPj[number]
type TProductMenu<Entity extends TEntity, UserType extends TUserType> = {
  [EntityKey in Entity extends 'BR'
    ? UserType extends 'PJ'
      ? TProductKeysBrPj
      : TProductKeysBrPf
    : TProductKey]: {
    isActive: boolean
    icon?: string
    name: string
    details?: string
    subProducts?: string[]
  }
}

enum ECummunicationPf {
  'DISABLE_ALL_COMMUNICATION_CHANNELS' = 'DISABLE_ALL_COMMUNICATION_CHANNELS',
  'EMAIL' = 'EMAIL',
  'PUSH' = 'PUSH',
  'SMS' = 'SMS',
  'WHATSAPP' = 'WHATSAPP',
  'PHONE' = 'PHONE',
}
enum ECummunicationPj {
  'DISABLE_ALL_COMMUNICATION_CHANNELS' = 'DISABLE_ALL_COMMUNICATION_CHANNELS',
  'PUSH_SMS' = 'PUSH_SMS',
  'SITE_APP_EXTERNOS' = 'SITE_APP_EXTERNOS',
  'LIGACAO' = 'LIGACAO',
  'WHATSAPP' = 'WHATSAPP',
  'EMAIL' = 'EMAIL',
}
type TCommunicationType<UserType extends TUserType> = UserType extends 'PJ'
  ? keyof typeof ECummunicationPj
  : keyof typeof ECummunicationPf
type TCommunications<UserType extends TUserType> = {
  [CommunicationType in TCommunicationType<UserType>]?: {
    icon?: string
    name: string
    key: TCommunicationType<UserType>
  }
}
type TProduct<UserType extends TUserType> = {
  title: string
  transactionalNotificationsSection?: {
    title: string
    details: string
  }
  marketingNotificationsSection: {
    title: string
    details: string
    communications: TCommunications<UserType>
  }
  alertSection: {
    icon: string
    details: string
  }
}

type TProducts<Entity extends TEntity, UserType extends TUserType> = {
  [EntityKey in Entity extends 'BR'
    ? UserType extends 'PJ'
      ? TProductKeysBrPj
      : TProductKeysBrPf
    : TProductKey]: TProduct<TUserType>
}

type TProductsMenu<Entity extends TEntity, UserType extends TUserType> = {
  title?: string
  productMenu: TProductMenu<Entity, UserType>
}

type TDontDisturbBottomsheet = TGenericFeedback & {
  site: string
}

type TManageNotifications<Entity extends TEntity, UserType extends TUserType> = {
  title: string
  headerSection: {
    title?: string
    details: string
  }
  alertSection?: {
    icon: string
    details: string
  }
  productsSection: TProductsMenu<Entity, UserType>
  doNotDisturbSection?: {
    contentPartOne: string
    contentPartTwo: string
    site: string
  }
}

export type {
  TProductKey,
  TProductKeysBrPf,
  TProductKeysBrPj,
  TProductMenu,
  TCommunicationType,
  TCommunications,
  TProduct,
  TProducts,
  TProductsMenu,
  TDontDisturbBottomsheet,
  TManageNotifications,
}

export { ProductKeys, ProductKeysBrPf, ProductKeysBrPj, ECummunicationPf, ECummunicationPj }
